<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '40%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false">
  <div class="row sticky dialog-title-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex relative align-centre dialog-title">
        <span class="textGreen font16 b-radius dialog-title-icon"
          [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
          <fa-icon [icon]="faDatabase"></fa-icon>
        </span>
        <span class="font17" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
          {{app.translations.SM_lbl_Title}}
        </span>
        <div class="absolute" style="right: 15px;">
          <span class="textGreen font16 b-radius dialog-title-icon cursorPointer" (click)="close()"
            [ngClass]="settings.darkModeSetting ? 'bg-dark-secondary' : 'bg-light-blue'">
            <fa-icon [icon]="faXmark"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <ng-container *ngIf="storageItems.length > 0">
      <div class="offset-10 col-2">
        <button class="btn float-right font14 float-right" (click)="deleteAll()"
          [ngClass]="settings.darkModeSetting ? 'textGreen' : 'textBlack'">
          {{app.translations.SM_btn_DeleteAll}}
        </button>
      </div>
      <div class="col-12 animated fadeIn padding15">
        <ng-container *ngFor="let item of storageItems">
          <div *ngIf="(item.filters && item.filters.length > 0) || (item.sort && item.sort.length > 0)" class="padding5"
            [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">
            <div class="row">
              <div class="col-12">
                <span class="font15 bold"
                  [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  {{item.viewName}}
                </span>
              </div>
            </div>
            <div class="row" *ngIf="item.filters && item.filters.length > 0">
              <div class="col-11">
                <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  Filters: {{item.filters}}
                </span>
              </div>
              <div class="col-1">
                <fa-icon [icon]="faTrash" class="font17 cursorPointer textRed float-right"
                  (click)="removeFilterItem(item)"></fa-icon>
              </div>
            </div>
            <div class="row" *ngIf="item.sort && item.sort.length > 0">
              <div class="col-11">
                <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                  Sort: {{item.sort}}
                </span>
              </div>
              <div class="col-1">
                <fa-icon [icon]="faTrash" class="font17 cursorPointer textRed float-right"
                  (click)="removeSortItem(item)"></fa-icon>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="storageItems.length == 0">
      <div class="col-12 padding15 flex justify-centre">
        <span class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
          {{app.translations.SM_lbl_NoStorageItems}}
        </span>
      </div>
    </ng-container>
  </div>
</p-dialog>